import "./polyfills";

import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import sysend from "sysend";

if (!import.meta.env.REACT_APP_BROADCAST_CHANNEL) {
	throw new Error("missing env variable: REACT_APP_BROADCAST_CHANNEL ");
}

const updateServiceWorker = (registration: ServiceWorkerRegistration) => {
	if (registration.waiting) {
		// navigator.serviceWorker.oncontrollerchange = () => {
		// 	try {
		// 		if (!import.meta.env.REACT_APP_BROADCAST_CHANNEL) {
		// 			throw new Error(
		// 				"missing env variable: REACT_APP_BROADCAST_CHANNEL "
		// 			);
		// 		}
		// 		sysend.broadcast(import.meta.env.REACT_APP_BROADCAST_CHANNEL, {
		// 			updateApp: true
		// 		});
		// 		window.location.reload(true);
		// 	} catch (error) {
		// 		console.error(error);
		// 	}
		// };
		registration.waiting?.postMessage("skipWaiting");

		// fallback if service worker doesn't behave correctly

		if (import.meta.env.REACT_APP_BROADCAST_CHANNEL) {
			sysend.broadcast(import.meta.env.REACT_APP_BROADCAST_CHANNEL, {
				updateApp: true
			});
		}
		window.location.reload();
	}
};

sysend.on(import.meta.env.REACT_APP_BROADCAST_CHANNEL, (data: any) => {
	if (data.updateApp) {
		window.location.reload();
	}
});

ReactDOM.render(
	<App updateServiceWorker={updateServiceWorker} />,
	document.getElementById("root")
);

if (import.meta.hot && import.meta.env.MODE === "development") {
	import.meta.hot.accept("./App", newModule => {
		if (newModule) {
			ReactDOM.render(
				<newModule.default updateServiceWorker={updateServiceWorker} />,
				document.getElementById("root")
			);
		}
	});
}

serviceWorker.register({
	onUpdate: registration => {
		const $customEvent = new CustomEvent("updateServiceWorker", {
			detail: { registration }
		});
		document.dispatchEvent($customEvent);
	}
});
